import { render, staticRenderFns } from "./app_new.vue?vue&type=template&id=55a24898&scoped=true&"
import script from "./app_new.vue?vue&type=script&lang=js&"
export * from "./app_new.vue?vue&type=script&lang=js&"
import style0 from "./app_new.vue?vue&type=style&index=0&id=55a24898&lang=scss&scoped=scoped&"
import style1 from "./app_new.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a24898",
  null
  
)

export default component.exports